import React, { ReactNode } from 'react';
import IcoClose from '../assets/images/button/ico-pop-close.svg';
import styled from 'styled-components';

const PopupSt = {
  Wrap: styled.div<{ width: number }>`
    position: fixed;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: ${(p) => p.width + 'px'};
    background: #fff;
    border-radius: 16px;
    box-shadow: 1px 1px 10px 0px #00000026;
  `,
  Inner: styled.div`
    padding: 24px;
  `,
  Head: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #dddddd;
  `,
  Cont: styled.div``,
  Title: styled.strong`
    font-size: 18px;
    font-weight: 600;
    color: #192640;
  `,
  Close: styled.button`
    width: 24px;
    height: 24px;
    background: url(${IcoClose}) no-repeat center;
  `,
};

interface PopupProps {
  width: number;
  title: string;
  children: ReactNode;
  onClose: () => void;
}

const PopupTemp = ({ width, title, children, onClose }: PopupProps) => {
  return (
    <PopupSt.Wrap width={width}>
      <PopupSt.Inner>
        <PopupSt.Head>
          <PopupSt.Title>{title}</PopupSt.Title>
          <PopupSt.Close type={'button'} onClick={onClose}>
            <span className={'hidden'}>닫기</span>
          </PopupSt.Close>
        </PopupSt.Head>
        <PopupSt.Cont>{children}</PopupSt.Cont>
      </PopupSt.Inner>
    </PopupSt.Wrap>
  );
};

export default PopupTemp;
